import axios from "axios";

const listEstados = () =>
  axios.get(
    `https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome`
  );

const listMunicipios = (estado) =>
  axios.get(
    `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${estado}/municipios?orderBy=nome`
  );

const buscaCep = (cep) => axios.get(`https://viacep.com.br/ws/${cep}/json/`);

const LocalidadeApiClient = { listEstados, listMunicipios, buscaCep };
export default LocalidadeApiClient;
